module.exports = __webpack_public_path__ + "img/img-24.fc3badf5.png";